let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7yTg7")).then(() => parcelRequire('cnwMf'));